import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const sendGuardSos = createAsyncThunk('sos/guard/send', async (data) => {
    var bodyFormData = new FormData()

    bodyFormData.append("complaint_category_id", data?.values?.complaint_category_id ?? '')
    bodyFormData.append("incident_remark", data?.values?.description ?? '')

    if (data?.values?.ticket_file && Array.isArray(data?.values?.ticket_file)) {
        data.values.ticket_file.forEach((file) => {
            bodyFormData.append("ticket_file", file)
        })
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'guard_sos',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "ticket_file", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const sendSos = createAsyncThunk('sos/send', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'send_sos',
            data: {
                description: data?.values?.description ?? ''
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const emergencyContactList = createAsyncThunk('sos/contact/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'sos_config',
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addEmergencyContact = createAsyncThunk('sos/contact/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'sos_config',
            data: {
                user_name: data?.values?.name ?? '',
                user_mobile: data?.values?.mobile_number ?? '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateEmergencyContact = createAsyncThunk('sos/contact/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'sos_config',
            data: {
                sos_id: data?.values?.id,
                user_name: data?.values?.name ?? '',
                user_mobile: data?.values?.mobile_number ?? '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delEmergencyContact = createAsyncThunk('sos/contact/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `sos_config/${data?.id}`,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const sos = createSlice({
    name: 'sos',
    initialState: {
        contacts: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(emergencyContactList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(emergencyContactList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.contacts = action?.payload?.data?.data ?? []
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.contacts = []
            }
        })
        builder.addCase(emergencyContactList.rejected, (state) => {
            state.loading = false
        })
    },
})

export default sos.reducer;